import { Slide } from "@mui/material";
import React from "react";

export const ModalTransition = React.forwardRef(function Transition(
  props,
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
